// extracted by mini-css-extract-plugin
export default {"img":"UnsubscribeComplete_img__CEoB9","sub":"UnsubscribeComplete_sub__iMixp"};